export const converting = {
    methods: {
        base64toBlob(base64Data, contentType) {
            contentType = contentType || '';
            let sliceSize = 1024,
                byteCharacters = atob(base64Data),
                bytesLength = byteCharacters.length,
                sliceCount = Math.ceil(bytesLength / sliceSize),
                byteArray = new Array (sliceCount);

            for ( let sliceIndex = 0; sliceIndex < sliceCount; ++sliceIndex) {
                let begin = sliceIndex * sliceSize,
                    end = Math.min(begin + sliceSize, bytesLength),
                    bytes = new Array(end - begin);

                for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
                    bytes[i] = byteCharacters[offset].charCodeAt(0);
                }
                byteArray[sliceIndex] = new Uint8Array(bytes);

            }

            return new Blob(byteArray, {type: contentType})
        },


        createUrlToFile(file) {
            let urlCreator  = window.URL || window.webkitURL;
            return urlCreator.createObjectURL(file);
        },

    }
};



// WEBPACK FOOTER //
// ./src/mixins/convertingMixin.js